var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AppMain"},[_c('transition',{attrs:{"name":"round-clip","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":"Home"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }